'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var desktop = require('@alfalab/core-components-button/desktop');
var components_baseCustomButton_baseCustomButton = require('../components/base-custom-button/base-custom-button.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var CustomButtonDesktop = React.forwardRef(function (_a, ref) {
    var children = _a.children, restProps = tslib.__rest(_a, ["children"]);
    return (React__default.default.createElement(components_baseCustomButton_baseCustomButton.BaseCustomButton, tslib.__assign({ ref: ref }, restProps, { componentButton: desktop.ButtonDesktop }), children));
});
CustomButtonDesktop.displayName = 'CustomButtonDesktop';

exports.CustomButtonDesktop = CustomButtonDesktop;
